window.checkPassword = () => {
  console.log('checkPassword called');

  const password = document.getElementById('password-input').value;
  const storeFrontToken = window.storeFrontToken;
  const loader = document.getElementById('loader');
  const currentPath = window.currentPath;
  const path = currentPath.split('/');
  loader.style.display = 'block';

  if (path.includes('collections') && !path.includes('products')) {
    const collectionId = window.collectionId;
    $.ajax({
      url: `https://apistaging.visualpromotions2.net/v1/shopifystore`,
      method: 'POST',
      headers: {
        'Store-Front-Token': `Token ${storeFrontToken}`
      },
      data: {
        collection_id: collectionId,
        password: password
      },
      success: handleResponse
    });
  } else {
    const productId = window.productId;
    $.ajax({
      url: `https://apistaging.visualpromotions2.net/v1/shopifyproduct`,
      method: 'POST',
      headers: {
        'Store-Front-Token': `Token ${storeFrontToken}`
      },
      data: {
        product_id: productId,
        password: password
      },
      success: handleResponse
    });
  }

  function handleResponse(response) {
    loader.style.display = 'none';
    if (response.isValid) {
      const header = document.querySelector('.brix---header-content-wrapper');
      if (header) {
        header.style.visibility = 'visible';
      }
      document.getElementById('password-modal').style.display = 'none';
      if (mainContent) {
        mainContent.style.visibility = 'visible';
      } else {
        const mainContent = document.querySelector('.brix---section');
        mainContent.style.visibility = 'visible';
      }
      const unlockedStores = JSON.parse(sessionStorage.getItem("unlockedStores") || "[]");
      const unlockedProducts = JSON.parse(sessionStorage.getItem("unlockedProducts") || "[]");
      if (window.collectionId && !unlockedStores.includes(window.collectionId)) {
        unlockedStores.push(window.collectionId);
        sessionStorage.setItem("unlockedStores", JSON.stringify(unlockedStores));
      }
      if (window.productId && !unlockedProducts.includes(window.productId)) {
        unlockedProducts.push(window.productId);
        sessionStorage.setItem("unlockedProducts", JSON.stringify(unlockedProducts));
      }
    } else {
      document.getElementById('password-error').style.display = 'block';
    }
  }
};